"use client";

import { useEffect, useState } from "react";
import { discoverWallets } from "./detect";
import type { DetectedWallet } from "./types";

export const useWallets = (enabled: boolean) => {
  const [wallets, setWallets] = useState<DetectedWallet[] | null>(null);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    return discoverWallets(setWallets);
  }, [enabled]);

  return wallets;
};
